import 'styles/App.scss';

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Container } from 'react-bootstrap';
import GlobalContextWrapper, { GlobalContext } from 'components/GlobalContext';
import { useContext, useRef } from 'react';
import { getCSSEnvironment, getEnvironment } from 'utilities/MiscUtilities';
import Directory from './Directory';
import DealersIndex from './Dealers/Index';
import FireDepartmentsIndex from './FireDepartments/Index';
import EquipmentIndex from './Equipment/Index';
import ProductsIndex from './Products/Index';
import FireStationsIndex from './FireStations/Index';
import HealthRiskAssessmentsIndex from './HealthRiskAssessments/Index';
import FormDirectoryIndex from './FormDirectory/Index';
import SalesRepsIndex from './SalesReps/Index';
import AirCardsIndex from './Aircards/Index';
import OpportunitiesIndex from './Opportunities/Index';
import RepDashboardIndex from './RepDashboard/Index';
import ToolsIndex from './Tools/Index';
import DeptDashboardIndex from './DeptDashboard/Index';
import DemosIndex from './Demos/Index';
import ContactsIndex from './Contacts/Index';
import ReportsIndex from './Reports/Index';
import EltsIndex from './Elts/Index';
import PostsIndex from './Posts/Index';
import SalesZonesIndex from './SalesZones/Index';
import ProductCategoriesIndex from './ProductCategories/Index';

const App = () => {
  // https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
  return (
    <>
      <BrowserRouter basename="/dps">
        <Container role={`main`} className={getCSSEnvironment()} style={{ backgroundColor: (getEnvironment() !== "prod" ? "rgba(255,0,0,0.1)" : "inherit") }}>
          <GlobalContextWrapper>
            <AppContent />
          </GlobalContextWrapper>
        </Container>
        <Container style={{ position: "relative" }}>
          © {(new Date()).getFullYear()} TFT, INC. ALL RIGHTS RESERVED.
        </Container>
      </BrowserRouter>
    </>
  );
}

const AppContent = () => {
  const globalContext = useContext(GlobalContext);
  const globalContextRef = useRef(globalContext);
  globalContextRef.current = globalContext;

  return (
    <Routes>
      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Dealers") &&
        <Route path="/Dealers/*" element={<DealersIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.FireDepartments") &&
        <Route path="/Departments/*" element={<FireDepartmentsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.FireStations") &&
        <Route path="/Station/*" element={<FireStationsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Equipment") &&
        <Route path="/Equipment/*" element={<EquipmentIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.AirCards") &&
        <Route path="/Aircards/*" element={<AirCardsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Demos") &&
        <Route path="/Demos/*" element={<DemosIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Components") &&
        <Route path="/Components/*" element={<DemosIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Products") &&
        <Route path="/Products/*" element={<ProductsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Products") &&
        <Route path="/ProductCategories/*" element={<ProductCategoriesIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Posts") &&
        <Route path="/Posts/*" element={<PostsIndex />} />
      }

      {
        globalContext.userType == 0 && (globalContext.roles.some(r => r === "Web.Opportunities" || r === "Web.Leads")) &&
        <Route path="/Opportunities/*" element={<OpportunitiesIndex />} />
      }

      {
        globalContext.userType == 0 && (globalContext.roles.some(r => r === "Web.Elts")) &&
        <Route path="/Elts/*" element={<EltsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.SalesRep") &&
        <Route path="/Reps/*" element={<SalesRepsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.HealthRiskAssessments") &&
        <Route path="/HealthRiskAssessments/*" element={<HealthRiskAssessmentsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Contacts") &&
        <Route path="/Contacts/*" element={<ContactsIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.SalesZones") &&
        <Route path="/SalesZones/*" element={<SalesZonesIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Tools") &&
        <Route path="/Tools/*" element={<ToolsIndex />} />
      }

      {
        globalContext.userType == 0 &&
        <Route path="/FormsDirectory/*" element={<FormDirectoryIndex />} />
      }

      {
        globalContext.userType == 0 && globalContext.roles.some(r => r === "Web.Reports") &&
        <Route path="/Reports/*" element={<ReportsIndex />} />
      }

      {
        globalContext.userType === 0 &&
        <Route path="*" element={<Directory />} />
      }

      {
        globalContext.userType === 1 &&
        <Route path="*" element={<RepDashboardIndex />} />
      }

      {
        globalContext.userType === 2 &&
        <Route path="*" element={<DeptDashboardIndex />} />
      }
    </Routes>
  )
}

export default App;